import SourceFlowImage from "@sourceflow-uk/sourceflowimage";
import useSimplePage from "@/hooks/useSimplePage";

import imagesMetaData from "@/../.sourceflow/image_metadata.json";
import roomImg from "@/assets/csr/banner-room.png";
import vector from "@/assets/csr/vector-csr.png";

export default function CsrPageGivingBack() {
  const page = useSimplePage("csr");

  return (
    <div className="relative">
      <div className="container flex flex-col items-center pt-10 relative z-30">
        {page && (
          <div
            className="text-xl [&>span]:text-xl sm:text-2xl [&>span]:sm:text-2xl [&>span]:md:text-3xl md:text-3xl/[42px] text-center max-w-[953px] w-full [&>span]:px-2 text-purple"
            dangerouslySetInnerHTML={{ __html: page?.content }}
          />
        )}
      </div>
      <div className="relative overflow-hidden top-[-144px] lg:top-0 min-h-[500px] lg:min-h-max hidden sm:flex pb-[50px]">
        <img
          src={vector ?? ""}
          alt="vector"
          className="absolute z-0 w-full hidden sm:block"
        />
        <SourceFlowImage
          imagesMetaData={imagesMetaData}
          path="csr_page.giving.image1"
          src={roomImg ?? ""}
          size="580x300"
          alt="giving back image 1"
          className="absolute hidden sm:block sm:-left-4 -top-10 sm:top-20 max-w-[448px] h-[558px] object-cover z-10"
        />
        <SourceFlowImage
          imagesMetaData={imagesMetaData}
          path="csr_page.giving.image2"
          src={roomImg ?? ""}
          size="580x300"
          alt="giving back image 2"
          className="absolute -right-12  max-w-[327px] h-[412px] object-cover hidden lg:block z-10"
        />
        <div className="container flex items-center justify-center pt-[164px] z-3 relative">
          <SourceFlowImage
            imagesMetaData={imagesMetaData}
            path="csr_page.giving.image3"
            src={roomImg ?? ""}
            size="580x300"
            alt="giving back image 3"
            className="max-w-[475px] h-[569px] object-cover hidden lg:block z-3"
          />
        </div>
      </div>
    </div>
  );
}
